const Visible = (props: any) => {
  const { children, condition, global } = props; 
  return (
    <div className={condition || global.googleMenuOpen ? '' : 'd-none'}>
      {children}
    </div>
  );
};

export default Visible;